import { NavigateNext} from '@mui/icons-material';
import { AppBar, Chip, Toolbar, Typography } from '@mui/material';
import { useAppContext } from 'AppContextProvider';
import { Grow } from 'components/Grow';
import TabBar from 'components/TabBar';
import { AppTab } from 'data/interfaces';
import { Logo } from './Logo';
import { NavUser } from './NavUser';
import {Fragment} from "react";
import {HelpLink} from "./HelpLink";

const Header = () => {
    const env = process.env.REACT_APP_ENV || '';
    const { state } = useAppContext();
    const { activeAccount } = state;

    const appTabs: AppTab[] = [
        { title: 'Users', path: `/accounts/${activeAccount?.accountId}/users` },
        { title: 'Roles and Services', path: `/accounts/${activeAccount?.accountId}/roles` },
    ];

    return (
        <AppBar position="sticky" color="default" elevation={0} sx={{backgroundColor: 'white'}}>
            <Toolbar sx={{borderBottom: '1px solid #ddd'}}>
                <Logo url="/" />

                { activeAccount &&    
                  <>
                    <NavigateNext sx={{ mr: 1 }} />
                    <Typography variant="h6" color="textSecondary" sx={{fontWeight: 100, textTransform: 'capitalize'}}>                   
                        {activeAccount.name}
                    </Typography>
                  </>              

                }

                <Grow />

                { env.toLowerCase().indexOf('prod') === -1 ? <Chip label={process.env.REACT_APP_ENV} /> : <Fragment/>}
                <HelpLink />
                <NavUser />
            </Toolbar>
            <TabBar tabs={appTabs} />
        </AppBar>
    );
};

export default Header;